import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getFeatureToggles = createAsyncThunk('getFeatureToggles', async () => {
    try {
        // Fetch all feature toggles
        const response = await axios.get(`/feature-toggles`);

        return response?.data;
    } catch (error) {
        // Squash the error and return an empty array
        return [];
    }
});
